export const educations = [
  {
    degree: "Master's in Information Technology - Data Science, AI and Machine Learning",
    university: "Halmstad University, Sweden",
    duration: "September 2025 - June 2027"
  },
  {
    degree: "Bachelor of Science in Computer Science and Engineering",
    university: "Stamford University Bangladesh",
    duration: "Graduated in 2017",
    cgpa: "3.96/4.00"
  }
];